var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, css } from "lit";
import { customElement, PICBase, PIC, PICAction } from "../Internals";
import { classMap } from 'lit/directives/class-map.js';
import { repeat } from 'lit/directives/repeat.js';
let PICBadge = class PICBadge extends PICBase {
    constructor() {
        super();
        this.pulsate = false;
        this.filterKey = '';
        this.showPicker = false;
        this.openDown = true;
        this.openLeft = true;
        this.isinput__ = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.isPicComp_ = false;
        PIC.getInstance.addNotificationConsumer(this);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        PIC.getInstance.removeNotificationConsumer(this);
    }
    handleNotification(iNotification) {
        this.pulsate = true;
        this.requestUpdate();
    }
    static get styles() {
        const defaultStyle = css `
            :host{
                /* The picker's search field is a bare <input> with no styling of
                   its own, so its background/text/caret come from the UA. This
                   flips that native chrome for dark mode. */
                color-scheme: var(--pic-colorScheme, light);
            }
            .cont{
                max-width: 32px;
                max-height: 32px;
                width: 32px;
            }
            .pic-badge{
                width: 32px;
            }
            .pic-badge:hover {
                cursor: pointer;
            }
            .pic-badge::before {
                font-family: "Material Design Icons";
                content: '\u{F009A}';
                font-size: 30px;
            }
            .pic-badge.outline::before {
                font-family: "Material Design Icons";
                content: '\u{F009C}';
                font-size: 30px;
            }
            .pic-count {
                position: relative;
                top: -34px;
                right: -15px;
                
                min-width: 10px;
                width: fit-content;
                padding: 2px;
                
                text-align: center;
                background-color: red;
                color: white;

                font-family: 'Montserrat';
                font-style: normal;
                font-weight: bold;
                font-size: 10px;
                line-height: 10px;

                border: 2px solid white;
                border-radius: 50%;                
            }
            .pic-count.pulse{
                -webkit-animation: pulse 1s ease-in-out 1 both;
	                    animation: pulse 1s ease-in-out 1 both;
            }

            @-webkit-keyframes pulse {
                from {
                    -webkit-transform: scale(1);
                            transform: scale(1);
                    -webkit-transform-origin: center center;
                            transform-origin: center center;
                    -webkit-animation-timing-function: ease-out;
                            animation-timing-function: ease-out;
                }
                33% {
                    -webkit-transform: scale(1.13);
                            transform: scale(1.13);
                    -webkit-animation-timing-function: ease-in;
                            animation-timing-function: ease-in;
                }
                45% {
                    -webkit-transform: scale(1);
                            transform: scale(1);
                    -webkit-animation-timing-function: ease-out;
                            animation-timing-function: ease-out;
                }
            }
            @keyframes pulse {
                from {
                    -webkit-transform: scale(1);
                            transform: scale(1);
                    -webkit-transform-origin: center center;
                            transform-origin: center center;
                    -webkit-animation-timing-function: ease-out;
                            animation-timing-function: ease-out;
                }
                33% {
                    -webkit-transform: scale(1.13);
                            transform: scale(1.13);
                    -webkit-animation-timing-function: ease-in;
                            animation-timing-function: ease-in;
                }
                45% {
                    -webkit-transform: scale(1);
                            transform: scale(1);
                    -webkit-animation-timing-function: ease-out;
                            animation-timing-function: ease-out;
                }
            }
            .invisiblecontainer{
                display: none;
                position: absolute;
                top: 30px;
                right: 10px;
                height: 500px;
                z-index: 5;
                border: 1px solid var(--pic-outline, black);
                border-radius: 2px;
                /* Menu/popover surface (dp1). In dark mode this is what
                   actually separates the picker from the page behind it
                   (#1e1e1e on #121212) - the drop shadow below barely reads
                   against a near-black background, same as pic-context. */
                background-color: var(--pic-surfaceColor, white);
                flex-direction: column;

                box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2);
            }
            .footer{
                border-top: 1px solid var(--pic-outline, black);
                color: var(--pic-onSurfaceHighColor, black);
            }
            .invisiblecontainer.up{
                top: -450px;
            }
            .invisiblecontainerl.left{
                right: -190px;
            }
            .invisiblecontainer.show{
                display: flex;
            }
            .hide{
                display: none;
            }
            .show{
                display: block;
            }
            .clickable{
                cursor: pointer;
            }
            .blanket{
                width: 200px;
                height: 470px;
                overflow-y: auto;
            }
            .searchfld{
                width: 96%;
            }
            .container{
                display: flex;
                align-items: center;
                flex-direction: row;
            }
            .container.title{
                justify-content: space-between;
                font-weight: bold;
            }
            .container.body{
                justify-content: flex-start;
                border-bottom: 1px solid var(--pic-outline, black);
            }
            .category{
                margin-left: 2px;   
            }
            .timestamp{
                margin-right: 2px;
            }
            .priority{
                width: 10px;
                min-width: 10px;
                max-width: 10px;
                height: 10px; 
                margin-left: 4px;
                margin-right: 4px;
                border-radius: 3px;
            }
            .priority.high{
                background-color: var(--pic-statusErrorColor);
            }
            .priority.medium{
                background-color: var(--pic-statusWarningColor);
            }
            .priority.low{
                background-color: var(--pic-statusOkColor);
            }
            .priority.info{
                background-color: var(--pic-statusInfoColor);
            }
            .message{
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-right: 4px;
            }
            
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    getIconClass() {
        return {
            'pic-badge': true,
            'outline': true,
        };
    }
    getCountClass() {
        return {
            'pic-count': true,
            'pulse': this.pulsate
        };
    }
    getHBClass() {
        return {
            'invisiblecontainer': true,
            'show': this.showPicker,
            'up': !this.openDown,
            'left': this.openLeft,
        };
    }
    renderPicker() {
        let br = this;
        return html `
            <div class=${classMap(this.getHBClass())}>
                <input class="searchfld" placeholder="Search" type=text @input=${filterNotifications} />
                <div class="blanket pic-caption">
                    ${repeat(PIC.getInstance.getNotifications(), (notific) => notific, (notific, index) => renderNotifications(notific, index))}
                </div>
                <div
                    class="footer pic-caption clickable" 
                    @click=${this.toggleNotificationCenter}>
                    open notificationcenter
                </div>
            </div>
        `;
        function filterNotifications(e) {
            br.filterKey = e.target.value.toLowerCase();
            br.requestUpdate();
        }
        function shouldHide(iKey) {
            // the wise guys of stackoverflow said this should be faster than regex
            if (iKey.toLowerCase().indexOf(br.filterKey) == -1)
                return 'hide';
            return 'show';
        }
        function clickable(iAction) {
            if (iAction)
                return ' clickable';
            return '';
        }
        function handleClick(e, iAction) {
            if (!iAction)
                return;
            let tmpAction = new PICAction();
            tmpAction.actionOptions = iAction;
            tmpAction.triggerEvent(e);
        }
        function renderNotifications(dat, index) {
            var _a, _b, _c;
            /* add dat.attrib to make it filterable  */
            return html `
                <div class=${shouldHide(dat.title + dat.category + dat.message + dat.priority) + clickable(dat.action)} 
                    @click=${(e) => { if (dat.action)
                handleClick(e, dat.action); }}>
                    <div class='title container pic-subtitle2'>
                        <div class='category'>
                            ${dat.category}
                        </div>
                        <div class='timestamp' title=${(_a = dat.timestamp) === null || _a === void 0 ? void 0 : _a.toLocaleString('en-GB')}>
                            ${((_b = dat.timestamp) === null || _b === void 0 ? void 0 : _b.getMonth()) + 1}/${(_c = dat.timestamp) === null || _c === void 0 ? void 0 : _c.getDate()}
                        </div>
                    </div>
                    <div class='body container pic-body2'>
                        <div class='priority ${dat.priority}'>
                        </div>
                        <div class='message' title="${dat.message}">
                            ${dat.title + ' '}${dat.message}
                        </div>
                    </div>
                </div>
            `;
        }
    }
    render() {
        return html `
            ${this.renderCSS(true)} 
            <div class="no-select">
                <div 
                    class=${classMap(this.getIconClass())} 
                    @click=${this.togglePicker}>
                    <div class=${classMap(this.getCountClass())} @animationend=${(e) => { this.pulsate = false; this.requestUpdate(); }}>${PIC.getInstance.getNotificationCount()}</div>
                </div>
                ${this.renderPicker()}
            </div>
        `;
    }
    ;
    togglePicker(e) {
        this.showPicker = !this.showPicker;
        this.openDown = this.getBoundingClientRect().bottom + 600 <= window.innerHeight;
        this.openLeft = this.getBoundingClientRect().left + 200 >= window.innerWidth;
        this.requestUpdate();
    }
    toggleNotificationCenter(e) {
        let center = document.querySelector('pic-notificationcenter[center-x]');
        if (!center) {
            center = document.createElement('pic-notificationcenter');
            center.setAttribute('center-x', '');
            document.body.appendChild(center);
        }
        center.toggle();
    }
};
PICBadge = __decorate([
    customElement('pic-badge')
], PICBadge);
export { PICBadge };
//# sourceMappingURL=PICBadge.js.map